import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 15v-6l7.745 10.65a9 9 0 1 1 2.255 -1.993","key":"svg-0"}],["path",{"d":"M15 12v-3","key":"svg-1"}]]

const IconBrandNextjs = createReactComponent('outline', 'brand-nextjs', 'BrandNextjs', __iconNode);

export default IconBrandNextjs;